// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalSnooze__pEtUB {
  height: 464px;
  width: 372px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.modalBody__snbdU {
  height: 100%;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding: 35px 51px 0;
}

.modalBodyTitle__TWs8p {
  text-align: center;
  margin-bottom: 20px;
  font-style: normal;
  color: var(--header-title-main);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  text-transform: uppercase;
}

.modalFooter__FOXKp {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 30px;
  padding: 0 51px 35px;
}

.textArea__r_Xmn {
  margin-top: 18px;
}

.skeletonDatePickerWrapper__jd0Fa {
  height: 70px;
}

.skeletonTextAreaWrapper__u8sJ_ {
  height: 112px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/EditSnoozeModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,OAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EA3BA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA7CF;;AAwEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;AArEF;;AAwEA;EACE,gBAAA;AArEF;;AAwEA;EACE,YAAA;AArEF;;AAyEA;EACE,aAAA;AAtEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.modalSnooze {\n  height: 464px;\n  width: 372px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.modalBody {\n  height: 100%;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  padding: 35px 51px 0;\n}\n\n.modalBodyTitle {\n  text-align: center;\n  margin-bottom: 20px;\n  font-style: normal;\n\n  @include modalTitle;\n}\n\n.modalFooter {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 30px;\n  padding: 0 51px 35px;\n}\n\n.textArea {\n  margin-top: 18px;\n}\n\n.skeletonDatePickerWrapper {\n  height: 70px;\n}\n\n\n.skeletonTextAreaWrapper {\n  height: 112px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalSnooze": `modalSnooze__pEtUB`,
	"modalBody": `modalBody__snbdU`,
	"modalBodyTitle": `modalBodyTitle__TWs8p`,
	"modalFooter": `modalFooter__FOXKp`,
	"textArea": `textArea__r_Xmn`,
	"skeletonDatePickerWrapper": `skeletonDatePickerWrapper__jd0Fa`,
	"skeletonTextAreaWrapper": `skeletonTextAreaWrapper__u8sJ_`
};
module.exports = ___CSS_LOADER_EXPORT___;
